import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { createI18n } from 'vue-i18n'
import naive, {
    NConfigProvider,
    NMessageProvider
} from 'naive-ui'

import en from './lang/en'
import de from './lang/de'

const messages = { en, de }

const themeOverrides = {
    common: {
        primaryColor: '#B19049',
        primaryColorHover: '#9E7F3F',
        primaryColorPressed: '#876B34',
        primaryColorSuppl: '#B19049',
        borderRadius: '10px',
        fontFamily: "'Libre Franklin', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    }
}

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'de',
    fallbackLocale: 'de',
    messages,
})

createInertiaApp({
    resolve: name => require(`./pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        const vueApp = createApp({
            render: () =>
                h(
                    NConfigProvider,           // Provider تنظیمات سراسری Naive UI
                    { themeOverrides },
                    {
                        default: () =>
                            h(
                                NMessageProvider,
                                null,
                                { default: () => h(App, props) }
                            )
                    }
                )
        })

        vueApp.use(plugin)
        vueApp.use(i18n)
        vueApp.use(naive)
        vueApp.mount(el)
    },
})
